"use client";

import { motion } from "framer-motion";
import { useTheme } from "next-themes";

import FlickeringGrid from "@/components/magicui/flickeringGrid";
import BentoExit from "@/components/salespage/sections/bentocards/bentoExit";
import BentoIntro from "@/components/salespage/sections/bentocards/bentoIntro";
import BentoRebalance from "@/components/salespage/sections/bentocards/bentoRebalance";
import BentoWeights from "@/components/salespage/sections/bentocards/bentoWeights";
import MaxWidthWrapper from "@/components/shared/max-width-wrapper";

const container = {
  hidden: { opacity: 0, y: -20 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      staggerChildren: 0.2,
      when: "beforeChildren",
    },
  },
};

const item = {
  hidden: { opacity: 0, y: -20 },
  show: { opacity: 1, y: 0 },
};

export default function BentoGrid() {
  const { theme } = useTheme();
  return (
    <section
      id="allocation"
      className="bg-background relative pt-8 lg:pt-16 pb-24"
    >
      <FlickeringGrid
        className="[mask-image:radial-gradient(ellipse_at_center,white,transparent)] z-0 absolute -top-24 inset-0 size-full"
        squareSize={2}
        gridGap={8}
        color={theme === "light" ? "#6B7280" : "#fff"}
        maxOpacity={0.3}
        flickerChance={0.6}
      />
      <MaxWidthWrapper>
        <motion.div
          className="relative z-10 grid grid-cols-6 gap-6"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* First card */}
          <motion.div
            className="flex justify-stretch items-stretch relative col-span-full  hover:shadow-xl  transition-shadow ease-in-out overflow-hidden lg:col-span-4"
            variants={item}
          >
            <BentoIntro />
          </motion.div>
          {/* Second card */}
          <motion.div
            className="flex justify-stretch items-stretch relative col-span-full overflow-hidden lg:col-span-2  hover:shadow-xl transition-all "
            variants={item}
          >
            <BentoWeights />
          </motion.div>
          {/* Second row */}
          <motion.div
            className="flex justify-stretch items-stretch relative col-span-full overflow-hidden lg:col-span-3  hover:shadow-xl transition-all "
            variants={item}
          >
            <BentoRebalance />
          </motion.div>
          <motion.div
            className="flex justify-stretch items-stretch relative col-span-full overflow-hidden lg:col-span-3  hover:shadow-xl transition-all "
            variants={item}
          >
            <BentoExit />
          </motion.div>
        </motion.div>
      </MaxWidthWrapper>
    </section>
  );
}
